import { Location } from '@angular/common';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { Router } from "@angular/router";
import { ContactDetailsSession } from '../../api/models/contactDetailsSession';
import { ProgressBarDetails } from '../../api/models/ProgressBarDetails';
import { SessionRequest } from '../../api/models/SessionRequest';
import { SessionResponse } from '../../api/models/SessionResponse';
import { ApiErrorCode, RouteURLConstants, ServiceURLConstants, UTagConstants } from '../../constants/upplm.constants';
import { TranslateDataPipe } from '../../pipes/translation.pipe';
import { UpsCommonService } from '../../services/upplm.common.service';
import { ProgressBarService } from '../../services/upplm.progressbar.service';
import { UpplmSessionService } from '../../services/upplm.session.service';
import { UtagService } from '../../services/upplm.utag.service';

@Component({
    selector: 'contactdetails',
    template: require('./contactDetails.component.html')
})

export class ContactDetailsComponent implements OnInit, AfterViewInit {
    sessionData: SessionResponse;
    public pbDetails: ProgressBarDetails;
    public isLoadding: boolean = false;
    public isInitialLoadding: boolean = true;
    @ViewChild('ConfirmationBox', { static: false }) ConfirmationBoxModal;
    @ViewChild('SessionErrorModal', { static: false }) SessionErrorModal;
    name: string = '';
    nameFlag: boolean = false;
    nameClass: string = 'ups-form_input ng-touched ng-dirty ng-valid';
    emailClass: string = 'ups-form_input ng-touched ng-dirty ng-valid';
    email: string = '';
    emailFlag: boolean = false;
    phone: string = '';
    phoneFlag: boolean = false;
    phoneIsValid: boolean = true;
    phoneClass: string = 'ups-form_input ng-touched ng-dirty ng-valid';
    ext: string = '';
    validEmail: boolean = false;

    makePrimaryContact: boolean = false;

    primaryName: string = '';
    primaryNameFlag: boolean = false;
    primaryNameClass: string = 'ups-form_input ng-touched ng-dirty ng-valid';
    primaryEmail: string = '';
    primaryEmailClass: string = 'ups-form_input ng-touched ng-dirty ng-valid';
    primaryEmailFlag: boolean = false;
    primaryPhone: string = '';
    primaryPhoneFlag: boolean = false;
    primaryPhoneIsValid: boolean = true;
    primaryPhoneClass: string = 'ups-form_input ng-touched ng-dirty ng-valid';
    primaryExt: string = '';
    validEmailPrimary: boolean = false;
    Errors: any[];

    constructor(private router: Router,
        private _sessionService: UpplmSessionService,
        private _commonService: UpsCommonService,
        private _pbService: ProgressBarService,
        private location: Location,
        private _utagService: UtagService,
        private _translateDataPipe: TranslateDataPipe
    ) { }

    ngOnInit() {

        this._utagService.utagForStartOfTheEvent(UTagConstants.UPPLM_CONTACT_DETAILS_START, UTagConstants.UPPLM_CONTACT_DETAILS_START_SCREEN);

        this.isInitialLoadding = true;
        this.emailFlag = false;
        this.primaryEmailFlag = false;
        this.pbDetails = this._pbService.pb;
        this.sessionData = this._sessionService.sessionData;
        this._sessionService.setSessionData(this._commonService.createURL(ServiceURLConstants.SET_UPPLM_SESSION, ApiErrorCode.SET_UPPLM_SESSION), this.createSessionRequest(false)).subscribe((response: SessionResponse) => {
            if (response.commonResponse.isSuccess && response.key && response.locationDetails != null) {
                this.sessionData = response;
                this._sessionService.mapSessionResponse(response);
                if (this.sessionData.locationDetails.city == null) {
                    this.goToLocation();
                }
                if (this.sessionData.contactDetails) {
                    this.bindDataFromSession(this.sessionData.contactDetails);
                }

            } else {
                this.SessionErrorModal.open();
            }
            this.isInitialLoadding = false;
        });
    }

    goToLocation() {
        this._pbService.pb = new ProgressBarDetails();
        this.router.navigateByUrl(RouteURLConstants.UPPLM_VIEW_LOCATIONS_DETAILS_ROUTE);
    }

    createSessionRequest(update: boolean): SessionRequest {
        let request: SessionRequest = new SessionRequest();
        request.key = this.sessionData.key;
        if (update) {
            let data: ContactDetailsSession = new ContactDetailsSession();
            data.name = this.name;
            data.email = this.email;
            data.phone = this.phone;
            data.ext = this.ext;
            data.makePrimaryContact = this.makePrimaryContact;
            data.primaryName = this.primaryName;
            data.primaryEmail = this.primaryEmail;
            data.primaryPhone = this.primaryPhone;
            data.primaryExt = this.primaryExt;
            request.contactDetails = data;
        }
        else {
            request.contactDetails = this.sessionData.contactDetails;
        }
        request.locationDetails = this.sessionData.locationDetails;
        request.temporaryLocation = this.sessionData.temporaryLocation;
        request.placardDetails = this.sessionData.placardDetails;
        request.pickupDetails = this.sessionData.pickupDetails;
        request.notificationDetails = this.sessionData.notificationDetails;
        request.lastTimeSessionReqired = new Date().toString();
        //request.pickupDetails.showPageEdit = true; 
        return request;
    }

    bindDataFromSession(data: ContactDetailsSession) {
        this.name = data.name;
        this.email = data.email;
        this.phone = data.phone;
        this.ext = data.ext;
        if (data.email != '') {
            this.onChange(this.email);
        }
        this.makePrimaryContact = data.makePrimaryContact;
        if (!this.makePrimaryContact) {
            this.primaryName = data.primaryName;
            this.primaryEmail = data.primaryEmail;
            this.primaryPhone = data.primaryPhone;
            this.primaryExt = data.primaryExt;
            if (data.primaryEmail != '') {
                this.onChangePrimary(this.primaryEmail);
            }
        }
    }

    ngAfterViewInit() {
        this.ConfirmationBoxModal.setProperties({
            title: this._translateDataPipe.transform('upplm.common.sessiontimedouttitle')});
        this.SessionErrorModal.setProperties({
            title: this._translateDataPipe.transform('upplm.common.serviceerror')
        });
    }

    nextPage() {
        if (!this._sessionService.isValidSession()) {
            this._pbService.pb = new ProgressBarDetails();
            this.ConfirmationBoxModal.open();
        }
        else {
            this.emailFlag = true;
            this.primaryEmailFlag = true;
            this.displayErrors();
            if (this.Errors.length == 0) {
                this.pbDetails = new ProgressBarDetails;
                this.pbDetails.locationPB = "true";
                this.pbDetails.contactPB = "true";
                this._pbService.pb = this.pbDetails;
                this.validateSessionAndNavigate(RouteURLConstants.UPPLM_VIEW_PLACARD_DETAILS_ROUTE);
            }
        }
    }

    backPage() {
        this.pbDetails = new ProgressBarDetails();
        this._pbService.pb = this.pbDetails;
        this.validateSessionAndNavigate(RouteURLConstants.UPPLM_VIEW_LOCATIONS_DETAILS_ROUTE);
    }

    saveGoReviewPage() {
        this.Errors = null;
        this.displayErrors();
        if (this.Errors.length == 0) {
            this.validateSessionAndNavigate(RouteURLConstants.UPPLM_VIEW_REVIEW_ROUTE);
        }
    }

    cancelGoReviewPage() {
        this.router.navigateByUrl(RouteURLConstants.UPPLM_VIEW_REVIEW_ROUTE);
    }

    cancelGoDashboardPage() {
        this._sessionService.cleanSessionData(this._commonService.createURL(ServiceURLConstants.CLEAN_SESSION, ApiErrorCode.CLEAN_SESSION)).subscribe((response: any) => {
            this._pbService.pb = new ProgressBarDetails();
            this._pbService.pb.showStatusBar = false;
            this._sessionService.mapSessionResponse(response);
            this.router.navigateByUrl(RouteURLConstants.UPPLM_VIEW_DASHBOARD_ROUTE);
        });
    }

    validateSessionAndNavigate(target: string) {
        this.isLoadding = true;
        if (!this._sessionService.isValidSession()) {
            this._pbService.pb = new ProgressBarDetails();
            this.ConfirmationBoxModal.open();
        }
        else {
            this._sessionService.setSessionData(this._commonService.createURL(ServiceURLConstants.SET_UPPLM_SESSION, ApiErrorCode.SET_UPPLM_SESSION), this.createSessionRequest(true)).subscribe((response: SessionResponse) => {
                if (response.commonResponse.isSuccess) {
                    this._sessionService.mapSessionResponse(response);
                    this.router.navigateByUrl(target);
                }
            });
        }
    }

    public focusoutHandler(field: string) {
        switch (field) {
            case 'name': {
                this.nameFlag = true;
                this.nameClass = this.name == '' ? "ups-form_input ng-pristine ng-invalid ups-bodError ng-touched" : "ups-form_input ng-touched ng-dirty ng-valid";
                break;
            }
            case 'phone': {
                this.validatePhone();
                break;
            }
            case 'primaryName': {
                if (!this.makePrimaryContact) {
                    this.primaryNameFlag = true;
                    this.primaryNameClass = this.primaryName == '' ? "ups-form_input ng-pristine ng-invalid ups-bodError ng-touched" : "ups-form_input ng-touched ng-dirty ng-valid";
                }
                break;
            }
            case 'primaryPhone': {
                this.validatePrimaryPhone();
                break;
            }
            case 'email': {
                this.emailFlag = true;
                this.emailClass = this.email == '' ? "ups-form_input ng-pristine ng-invalid ups-bodError ng-touched" : "ups-form_input ng-touched ng-dirty ng-valid";
                break;
            }
            case 'primaryEmail': {
                this.primaryEmailFlag = true;
                this.primaryEmailClass = this.email == '' ? "ups-form_input ng-pristine ng-invalid ups-bodError ng-touched" : "ups-form_input ng-touched ng-dirty ng-valid";
                break;
            }
        }
    }

    validatePhone() {
        let value = this.phone.toString().trim().replace(/^\+/, '');
        let valueChar = value.charAt(0) === '-' ? true : false;
        let valueMatch = value.match(/\d+$/) && !valueChar ? true : false;
        this.phoneFlag = true;
        this.phoneClass = this.phone == '' ? "ups-form_input ng-pristine ng-invalid ups-bodError ng-touched" : "ups-form_input ng-touched ng-dirty ng-valid";
        if (this.phone !== '') {
            this.phoneClass = !valueMatch ? "ups-form_input ng-pristine ng-invalid ups-bodError ng-touched" : "ups-form_input ng-touched ng-dirty ng-valid";
        }
        this.phoneIsValid = this.phoneClass !== "ups-form_input ng-touched ng-dirty ng-valid" ? false : true;
    }

    validatePrimaryPhone() {
        if (!this.makePrimaryContact) {
            let value = this.primaryPhone.toString().trim().replace(/^\+/, '');
            let valueChar = value.charAt(0) === '-' ? true : false;
            let valueMatch = value.match(/\d+$/) && !valueChar ? true : false;
            this.primaryPhoneFlag = true;
            this.primaryPhoneClass = this.primaryPhone == '' ? "ups-form_input ng-pristine ng-invalid ups-bodError ng-touched" : "ups-form_input ng-touched ng-dirty ng-valid";
            if (this.primaryPhone !== '') {
                this.primaryPhoneClass = !valueMatch ? "ups-form_input ng-pristine ng-invalid ups-bodError ng-touched" : "ups-form_input ng-touched ng-dirty ng-valid";
            }
            this.primaryPhoneIsValid = this.primaryPhoneClass !== "ups-form_input ng-touched ng-dirty ng-valid" ? false : true;
        }
    }

    displayErrors() {
        this.Errors = [];
        this.nameErrorValidation();
        this.phoneErrorValidation();
        this.emailErrorValidation();
        if (!this.makePrimaryContact) {
            if (this.primaryName == '') {
                this.focusoutHandler('primaryName');
                this.Errors = this.Errors.concat(this.addError('primaryContactName', this._translateDataPipe.transform('upplm.contactdetails.primarycontactnameisrequired'), 'required'));
            }
            if (this.primaryPhone == '') {
                this.focusoutHandler('primaryPhone');
                this.Errors = this.Errors.concat(this.addError('primaryPhoneNumber', this._translateDataPipe.transform('upplm.contactdetails.primaryphoneisrequired'), 'required'));
            }
            else {
                if (!this.primaryPhoneIsValid) {
                    this.Errors = this.Errors.concat(this.addError('primaryPhoneNumber', this._translateDataPipe.transform('upplm.contactdetails.primaryphoneisinvalid'), 'invalidFormat'));
                }
            }
            if (this.primaryEmail == '') {
                this.focusoutHandler('primaryEmail');
                this.validEmailPrimary = false;
                this.Errors = this.Errors.concat(this.addError('primaryContactEmail', this._translateDataPipe.transform('upplm.contactdetails.primaryemailisrequired'), 'required'));
            }
            else {
                if (!this.validEmailPrimary) {
                    this.Errors = this.Errors.concat(this.addError('primaryContactEmail', this._translateDataPipe.transform('upplm.contactdetails.primaryemailisinvalid'), 'invalidFormat'));
                }
            }
        }
    }

    nameErrorValidation() {
        if (this.name == '') {
            this.focusoutHandler('name');
            this.Errors = this.Errors.concat(this.addError('contactName', this._translateDataPipe.transform('upplm.contactdetails.nameisrequired'), 'required'));
        }
    }

    phoneErrorValidation() {
        if (this.phone == '') {
            this.focusoutHandler('phone');
            this.Errors = this.Errors.concat(this.addError('phoneNumber', this._translateDataPipe.transform('upplm.contactdetails.phoneisrequired'), 'required'));
        } else {
            if (!this.phoneIsValid) {
                this.Errors = this.Errors.concat(this.addError('phoneNumber', this._translateDataPipe.transform('upplm.contactdetails.phoneisinvalid'), 'invalidFormat'));
            }
        }
    }

    emailErrorValidation() {
        if (this.email == '') {
            this.focusoutHandler('email');
            this.validEmail = false;
            this.Errors = this.Errors.concat(this.addError('contactEmail', this._translateDataPipe.transform('upplm.common.emailisrequired'), 'required'));
        } else {
            if (!this.validEmail) {
                this.Errors = this.Errors.concat(this.addError('contactEmail', this._translateDataPipe.transform('upplm.contactdetails.emailisinvalid'), 'invalidFormat'));
            }
        }
    }

    addError(id: string, field: string, condition: string): any {
        return [{
            "id": id,
            "displayText": field,
            "type": condition,
            "fieldName": "Name",
            "fieldError": "Name error",
            "fieldErrorDescription": "field Error"
        }];
    }

    onChange(newValue) {
        const validEmailRegEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (validEmailRegEx.test(newValue)) {
            this.validEmail = true;
        } else {
            this.validEmail = false;
        }
        this.emailFlag = true;
    }

    onChangePrimary(newValue) {
        const validEmailRegEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (validEmailRegEx.test(newValue)) {
            this.validEmailPrimary = true;
        } else {
            this.validEmailPrimary = false;
        }
        this.primaryEmailFlag = true;
    }

    focusInput(item: any) {
        document.getElementById(item.id).focus();
    }
}
